import { Static, TSchema, Type } from '@sinclair/typebox';

export function makeNullable<T extends TSchema>(schema: T) {
    return Type.Unsafe<Static<T> | null>({ ...schema, nullable: true });
}

export function makeStringEnum<T extends string[]>(values: [...T]) {
    return Type.Unsafe<T[number]>({ type: 'string', enum: values });
}
